import React, { Fragment, useEffect, useMemo } from 'react';
import { LightboxStyles, ReviewsSectionWrapper, ReviewsTitle } from './styled';
import { isServerSideRendering } from 'helpers/env';

type YotpoProductProps = {
  className?: string;
  productId: string;
  productPrice?: string;
  productUrl?: string;
  productName?: string;
  productImage?: string;
  reviewHtml: string;
};

const Yotpo = ({
  className = '',
  productUrl,
  productId,
  productPrice,
  productName,
  productImage,
  reviewHtml
}: YotpoProductProps): React.JSX.Element => {
  const instanceId = process.env.GATSBY_YOTPO_INSTANCE_ID;

  const innerHtml = useMemo(() =>
      isServerSideRendering() ? { __html: reviewHtml } : undefined,
    [reviewHtml]);

  useEffect(() => {
    if (isServerSideRendering()) {
      return;
    }
    // Wait for Yotpo script to load then initialize widget
    const interval = setInterval(() => {
      if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
        window.yotpoWidgetsContainer.initWidgets();
        clearInterval(interval);
      }
    }, 100);
    return () => clearInterval(interval);
  }, [productId]);

  return (
    <Fragment>
      <LightboxStyles/>
      <ReviewsSectionWrapper className={className}>
        <button className="button-link" id="yotpo-reviews-anchor"/>
        <ReviewsTitle>Take it from our community...</ReviewsTitle>

        <div
          id="y-embedded-widget"
          className="yotpo-widget-instance"
          data-yotpo-instance-id={instanceId}
          data-yotpo-product-id={productId}
          data-yotpo-name={productName}
          data-yotpo-url={productUrl}
          data-yotpo-image-url={productImage}
          data-yotpo-price={productPrice}
          data-yotpo-currency="USD"
          data-yotpo-description="Product Description"
          dangerouslySetInnerHTML={innerHtml}
        />
      </ReviewsSectionWrapper>
    </Fragment>
  );
};

export default Yotpo;